<ng-container *ngIf="!guided && !showIntro">
    <div class="list" [class.scroll]="!!question">

        <ng-container *ngIf="question">
            <h2 class="block-title">{{question.label}}</h2>
            <ng-container *ngIf="thought">
                <p class="paragraph-15">
                    {{'thoughtRecord.assessment.thoughtXOfY' | translate:{
                    index: thoughtIndex + 1,
                    count: thoughtTotal
                } }}
                </p>
                <p class="paragraph-15">{{thought}}</p>
            </ng-container>
        </ng-container>

        <ion-list>
            <ion-item *ngFor="let text of texts; let i = index" lines="none">
                <ion-label class="paragraph-15">{{text}}</ion-label>
                <ion-button *ngIf="!readOnly" slot="end" size="extra-small" color="warning" (click)="removeText(i)">
                    <ion-icon slot="icon-only" class="icon haleo-trash"></ion-icon>
                </ion-button>
            </ion-item>
        </ion-list>

        <ion-textarea *ngIf="showTextarea"
                      #textarea
                      rows="7"
                      autocapitalize="on"
                      spellcheck="true"
                      [placeholder]="placeHolder"
                      [(ngModel)]="value"></ion-textarea>

        <ion-button *ngIf="!showTextarea && !readOnly"
                    class="add-thought"
                    expand="block" fill="outline" color="primary"
                    (click)="newText()">
            <ion-icon slot="start" class="icon haleo-plus"></ion-icon>
            {{addElementBtnText | translate}}
        </ion-button>
        <ion-button *ngIf="!readOnly && guideSteps && guideSteps.length > 0"
                    color="primary"
                    fill="clear"
                    class="guide-me"
                    (click)="guided = true">
            {{'thoughtRecord.assessment.guideMe'| translate}}
        </ion-button>
        <div id="bottom"></div>
    </div>

    <ion-buttons *ngIf="!readOnly" [class.integrated]="!question">
        <ion-button *ngIf="challengeThoughts && texts?.length == 0"
                    color="primary"
                    fill="outline"
                    (click)="continue()">
            {{'thoughtRecord.assessment.skip' | translate}}
        </ion-button>
        <ion-button *ngIf="showTextarea && texts && texts.length > 0"
                    color="primary"
                    fill="outline"
                    (click)="showTextarea = false">
            {{'thoughtRecord.assessment.cancel' | translate}}
        </ion-button>
        <ion-button *ngIf="showTextarea"
                    color="primary"
                    fill="outline"
                    [disabled]="!value || value.length == 0"
                    (click)="addText()">
            {{'thoughtRecord.assessment.add' | translate}}
        </ion-button>
        <ion-button *ngIf="question && !showTextarea"
                    color="secondary"
                    fill="solid"
                    [disabled]="!texts || texts.length == 0" (click)="continue()">
            {{'thoughtRecord.assessment.continue' | translate}}
        </ion-button>
    </ion-buttons>
</ng-container>
<ng-container *ngIf="guided && !showIntro">
    <app-thought-record-question-text-list-guided [steps]="guideSteps"
                                                  (answered)="guidedAnswered($event)"
    ></app-thought-record-question-text-list-guided>
</ng-container>
<div *ngIf="showIntro" class="intro ion-text-center">
    <img src="assets/img/thought-record/balanced-thoughts.png"/>
    <h1 class="hero-title" [innerHTML]="'thoughtRecord.assessment.balancedThoughts' | translate"></h1>
    <p class="paragraph-15">{{'thoughtRecord.assessment.balancedThoughtsDescription' | translate}}</p>
    <ion-button color="secondary" fill="clear" (click)="showIntro = false">
        {{'thoughtRecord.assessment.start'| translate}}
    </ion-button>
</div>
